import React from 'react';
import {
  AppBar,
  AppBarDataCustomItem,
  ScrollableViewport,
} from '@ihsm/ui-shared';
import { useAppSelector } from 'state/store';
import { TransparentButton } from 'shared/components/Buttons';
import { currentMetricSelector } from 'state/store/selectors';
import { PageContent } from 'shared/components/PageContent';
import { InnerPagePadding } from 'shared/components/InnerPagePadding';
import { HeaderButtonWrapper } from 'shared/components/HeaderButtonWrapper';
import { useGetMetricsQuery } from 'services/newApi/metricsApi';
import { NewMetricsForm } from '../components/NewMetricsForm';
import { SearchTreeMetrics } from '../components/SearchTreeMetrics';

export const Metrics: React.FC = (): JSX.Element => {
  const currentMetric = currentMetricSelector(useAppSelector((state) => state));

  useGetMetricsQuery();

  const editButton: AppBarDataCustomItem = {
    type: 'customOption',
    component: (
      <HeaderButtonWrapper>
        <TransparentButton
          iconSrc="Edit"
          text="Edit"
          onClick={() => {}}
          disabled
        />
      </HeaderButtonWrapper>
    ),
  };

  return (
    <PageContent
      searchTree={<SearchTreeMetrics disableAddButton />}
      headerControls={
        <AppBar menuItems={[editButton]}>
          {currentMetric?.name || 'No Metric Selected'}
        </AppBar>
      }
    >
      <ScrollableViewport vertical>
        <InnerPagePadding>
          <NewMetricsForm form={currentMetric} disabled />
        </InnerPagePadding>
      </ScrollableViewport>
    </PageContent>
  );
};
